import React from 'react'
import styled from 'styled-components'

import CMS from '@talus-analytics/library.airtable-cms'
import useFooterData from '../../cmsHooks/useFooterData'

const FooterContainer = styled.footer`
  height: 90px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.colorVeryDarkGray};
`

const Footer = () => {
  const data = useFooterData()

  return (
    <FooterContainer>
      <a href="https://talusanalytics.com/" target="_blank">
        <CMS.Image data={data} name={'Talus logo'} />
      </a>
    </FooterContainer>
  )
}

export default Footer
